import { Box, Link } from '@mui/material';
import { DashboardRounded } from '@mui/icons-material';


export default function SitemarkIcon(props) {
  return (
    <Box sx={{ height: 38, width: 80,  }} >
        <Link href="/" underline="none" >
            <img
                src={`${process.env.PUBLIC_URL}/images/logo.svg`}
                alt="logo"
                style={{
                    left: "0",
                    position: "absolute",
                    top: "0",
                    paddingLeft: "24px",
                    width: '74px',
                    height: '100%',
                }}
                {...props}
            />
        </Link>
    </Box>
  );
}


export function CustomIcon() {
  return (
    <Box
      sx={{
        width: '1.5rem',
        height: '1.5rem',
        bgcolor: 'black',
        borderRadius: '999px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
        backgroundImage:
          'linear-gradient(135deg, hsl(210, 98%, 60%) 0%, hsl(210, 100%, 35%) 100%)',
        color: 'hsla(210, 100%, 95%, 0.9)',
        border: '1px solid',
        borderColor: 'hsl(210, 100%, 55%)',
        boxShadow: 'inset 0 2px 5px rgba(255, 255, 255, 0.3)',
      }}
    >
      <DashboardRounded color="inherit" sx={{ fontSize: '1rem' }} />
    </Box>
  );
}